/* Kaas & Borrelz – kaartje met bericht toevoegen vanuit de cart drawer */
(function () {
  if (customElements.get('kb-card-option')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class KbCardOption extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.toggle = this.querySelector('[data-kb-card-toggle]');
      this.fields = this.querySelector('[data-kb-card-fields]');
      this.message = this.querySelector('[data-kb-card-message]');
      this.count = this.querySelector('[data-kb-card-count]');
      this.button = this.querySelector('[data-kb-card-add]');
      this.error = this.querySelector('[data-kb-card-error]');

      this.toggle.addEventListener('change', () => {
        this.fields.hidden = !this.toggle.checked;
        if (this.toggle.checked) this.message.focus();
      });

      this.message.addEventListener('input', () => {
        this.count.textContent = this.message.value.length + '/200';
        this.showError('');
      });

      this.button.addEventListener('click', () => this.addCard());

      // Dubbele check: zit er (net) al een kaartje in de winkelwagen, bijvoorbeeld
      // via de borrelpakket-pagina, dan verbergen we de optie direct.
      this.checkExistingCard();
    }

    async fetchCart() {
      var response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      return response.json();
    }

    hasCard(cart) {
      var variantId = Number(this.dataset.variantId);
      return cart.items.some(function (item) { return item.variant_id === variantId; });
    }

    async checkExistingCard() {
      try {
        var cart = await this.fetchCart();
        if (this.hasCard(cart)) {
          this.hidden = true;
          this.refreshDrawer();
        }
      } catch (e) { /* geen probleem: de server-check blijft gelden */ }
    }

    showError(text) {
      this.error.textContent = text;
      this.error.hidden = !text;
    }

    async addCard() {
      var text = this.message.value.trim();

      if (!text) {
        this.showError('Vul eerst een bericht in voor op het kaartje.');
        this.message.focus();
        return;
      }

      this.button.disabled = true;
      this.button.textContent = 'Bezig…';

      try {
        // Laatste check vlak voor het toevoegen: nooit een tweede kaartje
        if (this.hasCard(await this.fetchCart())) {
          this.hidden = true;
          this.refreshDrawer();
          return;
        }
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(this.dataset.variantId),
              quantity: 1,
              properties: { 'Bericht op kaartje': text }
            }]
          })
        });

        if (!response.ok) throw new Error('add failed');

        var cart = await this.fetchCart();

        // Laat Prestige de drawer en het winkelwagen-icoontje bijwerken
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));

        // Vangnet: staat de optie er na korte tijd nog, dan verversen we de drawer zelf
        setTimeout(() => {
          if (this.isConnected) this.refreshDrawer();
        }, 700);
      } catch (e) {
        this.showError('Het kaartje kon niet worden toegevoegd. Probeer het opnieuw.');
        this.button.disabled = false;
        this.button.textContent = 'Kaartje toevoegen';
      }
    }

    async refreshDrawer() {
      try {
        var id = this.dataset.sectionId;
        var response = await fetch(root + '?sections=' + encodeURIComponent(id));
        var data = await response.json();
        var doc = new DOMParser().parseFromString(data[id], 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var current = this.closest('cart-drawer');

        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } catch (e) {
        window.location.reload();
      }
    }
  }

  customElements.define('kb-card-option', KbCardOption);
})();
